"use strict";
/**
 * The ConfigService is used for setting up the node address,
 * the logging level as well as storing custom configuration options.
 *
 * @packageDocumentation
 * @module ConfigService
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingFactory = exports.set = exports.get = exports.modifyLogLevel = void 0;
const typescript_logging_1 = require("typescript-logging");
const utils_1 = require("@kiltprotocol/utils");
const DEFAULT_DEBUG_LEVEL = process.env.DEBUG && process.env.DEBUG === 'true'
    ? typescript_logging_1.LogLevel.Debug
    : typescript_logging_1.LogLevel.Error;
/**
 *  Changes all existing Loggers of our default Factory with id 0 to the intended Level.
 *
 * @param level The intended LogLevel. LogLevel has a range of 0 to 5.
 * @returns The new set level.
 */
function modifyLogLevel(level) {
    // eslint-disable-next-line no-nested-ternary
    const actualLevel = level > 0 ? (level > 5 ? 5 : level) : 0;
    typescript_logging_1.getLogControl()
        .getLoggerFactoryControl(0)
        .change({
        group: 'all',
        logLevel: typescript_logging_1.LogLevel[actualLevel],
    });
    return actualLevel;
}
exports.modifyLogLevel = modifyLogLevel;
let configuration = {
    logLevel: DEFAULT_DEBUG_LEVEL,
    address: '',
};
function checkAddress() {
    if (!configuration.address) {
        throw utils_1.SDKErrors.ERROR_WS_ADDRESS_NOT_SET();
    }
}
function get(configOpt) {
    switch (configOpt) {
        case 'address':
            checkAddress();
            break;
        default:
    }
    if (typeof configuration[configOpt] === 'undefined')
        throw new Error(`GENERIC NOT CONFIGURED ERROR FOR KEY: "${configOpt}"`);
    return configuration[configOpt];
}
exports.get = get;
function setLogLevel(logLevel) {
    if (logLevel || logLevel === 0) {
        modifyLogLevel(logLevel);
    }
}
function set(opts) {
    configuration = Object.assign(Object.assign({}, configuration), opts);
    setLogLevel(configuration.logLevel);
}
exports.set = set;
// Create options instance and specify 1 LogGroupRule:
// * LogLevel Error on default, env DEBUG = 'true' changes Level to Debug.throws
const options = new typescript_logging_1.LoggerFactoryOptions().addLogGroupRule(new typescript_logging_1.LogGroupRule(new RegExp('.+'), get('logLevel')));
// Create a named loggerfactory and pass in the options and export the factory.
// Named is since version 0.2.+ (it's recommended for future usage)
// eslint-disable-next-line import/prefer-default-export
exports.LoggingFactory = typescript_logging_1.LFService.createNamedLoggerFactory('LoggerFactory', options);
